var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6253 4.68737L27.3126 9.37474L22.6253 14.0621L17.9379 9.37474L22.6253 4.68737V4.68737ZM9.93789 5.4824V12.1077H3.31263V5.4824H9.93789ZM26.501 22.0455V28.6708H19.8758V22.0455H26.501ZM9.93789 22.0455V28.6708H3.31263V22.0455H9.93789ZM22.6253 0L13.2505 9.35818L22.6253 18.7329L32 9.35818L22.6253 0ZM13.2505 2.16977H0V15.4203H13.2505V2.16977ZM29.8137 18.7329H16.5631V31.9834H29.8137V18.7329ZM13.2505 18.7329H0V31.9834H13.2505V18.7329Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupWhatsapp);
export default __webpack_public_path__ + "static/media/signupWhatsapp.9b4b68b3.svg";
export { ForwardRef as ReactComponent };